import {PaycardStatusEnum} from '../../shared/services/paycard/paycard.status.enum';

export class GetPaycards {
  static readonly type = '[paycards] get paycards';
  constructor(public page?: number, public size?: number, public paycardId?: string, public status?: PaycardStatusEnum) {}
}

export class GetPaycardDetail {
  static readonly type = '[paycards] get paycard detail by id';
  constructor(public paycardId: string) {}
}

export class ResetPaycardPin {
  static readonly type = '[paycards] reset paycard pin';
  constructor(public paycardId: string) {}
}

export class DeletePaycard {
  static readonly type = '[paycards] delete paycard';
  constructor(public paycardId: string) {}
}
